// Pixel breakpoints measured from the widget cell (BaseMapWidgetContainer
// reports containerSizePx), so the same grid span adapts on mobile widths.
export const HURRICANES_WIDGET_STACKED_MAX_WIDTH_PX = 560;
export const HURRICANES_WIDGET_COMPACT_MAX_WIDTH_PX = 420;
export const HURRICANES_WIDGET_REPLAY_TIMESTAMP_MIN_WIDTH_PX = 300;

// Explicit layout settings per resolved layout so the widget markup stays
// free of one-off dimension checks.
export const HURRICANES_WIDGET_LAYOUT_CONFIG = Object.freeze({
  '2x1': Object.freeze({
    contentClassName: 'd-flex flex-row flex-fill w-100 gap-2 overflow-hidden min-h-0',
    informationClassName: 'hurricanes-widget-details d-flex flex-column gap-2 overflow-auto h-100',
    informationStyle: Object.freeze({ flex: '0 0 42%' }),
    mapClassName: 'flex-fill h-100 d-flex min-w-0',
    mapStyle: Object.freeze({}),
    showInformationPanel: true,
    showDatasetToggle: true,
    showPlaybackSpeedControl: true,
  }),
  '1x2': Object.freeze({
    contentClassName: 'd-flex flex-column flex-fill w-100 gap-2 overflow-hidden min-h-0',
    informationClassName:
      'hurricanes-widget-details d-flex flex-column gap-2 overflow-auto flex-fill',
    informationStyle: Object.freeze({}),
    mapClassName: 'w-100 d-flex',
    mapStyle: Object.freeze({ flex: '0 0 52%', minHeight: 0 }),
    showInformationPanel: true,
    showDatasetToggle: true,
    showPlaybackSpeedControl: true,
  }),
  '1x1': Object.freeze({
    contentClassName: 'd-flex flex-column flex-fill w-100 gap-2 overflow-hidden min-h-0',
    informationClassName: '',
    informationStyle: Object.freeze({}),
    mapClassName: 'flex-fill w-100 d-flex',
    mapStyle: Object.freeze({}),
    showInformationPanel: false,
    showDatasetToggle: false,
    showPlaybackSpeedControl: false,
  }),
});
